import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-blue-900 pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-75">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-76">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center mix-blend-overlay" data-id="element-77"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/50 to-blue-900" data-id="element-78"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-80">
          {/* Content */}
          <div className="text-center lg:text-left" data-id="element-81">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-800/50 border border-blue-700 text-blue-100 text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-82">
              <span className="flex h-2 w-2 rounded-full bg-red-500 mr-2" data-id="element-83"></span>
              Premium Quality Screen Printing
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6" data-id="element-84">
              Make Your Brand <br data-id="element-85" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600" data-id="element-86">
                Impossible to Ignore
              </span>
            </h1>

            <p className="text-lg md:text-xl text-blue-100 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-87">
              Professional screen printing for businesses, brands, and events.
              We deliver sharp details, vibrant colors, and durability that
              lasts wash after wash.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-10" data-id="element-88">
              <Button size="lg" className="w-full sm:w-auto group" data-id="element-89">
                Get Free Quote
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-90" />
              </Button>
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-blue-400 text-blue-100 hover:bg-blue-800/50 hover:text-white hover:border-white" data-id="element-91">
                View Our Work
              </Button>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-x-8 gap-y-4 text-sm text-blue-200 font-medium" data-id="element-92">
              <div className="flex items-center" data-id="element-93">
                <CheckCircle2 className="h-4 w-4 text-red-500 mr-2" data-id="element-94" />
                5-Day Turnaround
              </div>
              <div className="flex items-center" data-id="element-95">
                <CheckCircle2 className="h-4 w-4 text-red-500 mr-2" data-id="element-96" />
                No Minimum Orders
              </div>
              <div className="flex items-center" data-id="element-97">
                <CheckCircle2 className="h-4 w-4 text-red-500 mr-2" data-id="element-98" />
                Free Design Review
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative hidden lg:block" data-id="element-99">
            <div className="absolute -inset-4 bg-red-600/20 rounded-2xl blur-xl transform rotate-3" data-id="element-100"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-blue-700/50 bg-blue-800/50 backdrop-blur-sm aspect-[4/3] group" data-id="element-101">
              {/* Abstract representation of a print shop or t-shirt stack */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-800 to-blue-950 flex items-center justify-center" data-id="element-102">
                <div className="grid grid-cols-2 gap-4 p-8 w-full h-full opacity-80" data-id="element-103">
                  <div className="bg-blue-700/30 rounded-lg h-full w-full animate-pulse" data-id="element-104"></div>
                  <div className="bg-blue-600/30 rounded-lg h-3/4 w-full self-end" data-id="element-105"></div>
                  <div className="bg-red-900/20 rounded-lg h-full w-full" data-id="element-106"></div>
                  <div className="bg-blue-700/30 rounded-lg h-5/6 w-full" data-id="element-107"></div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-108">
                  <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-xl shadow-xl transform transition-transform group-hover:scale-105 duration-500" data-id="element-109">
                    <div className="flex items-center space-x-4 mb-4" data-id="element-110">
                      <div className="h-12 w-12 bg-red-600 rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-111">
                        L
                      </div>
                      <div data-id="element-112">
                        <div className="h-2 w-24 bg-white/80 rounded mb-2" data-id="element-113"></div>
                        <div className="h-2 w-16 bg-white/50 rounded" data-id="element-114"></div>
                      </div>
                    </div>
                    <div className="space-y-2" data-id="element-115">
                      <div className="h-2 w-48 bg-white/30 rounded" data-id="element-116"></div>
                      <div className="h-2 w-40 bg-white/30 rounded" data-id="element-117"></div>
                      <div className="h-2 w-44 bg-white/30 rounded" data-id="element-118"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}